module.exports = __webpack_public_path__ + "img/game-feature6.5e7fd783.png";